/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Refresh_Presets_Button_TitleInputs */



/**
* | output |
* | --- |
* | "Refresh Presets" |
*
* @param {Styles_Refresh_Presets_Button_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_refresh_presets_button_title = /** @type {((inputs?: Styles_Refresh_Presets_Button_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Refresh_Presets_Button_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actualiser les presets")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellungen aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna preimpostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительные настройки обновления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar ajustes preestablecidos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("刷新预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットを更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट रीफ़्रेश करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar predefinições")
	return /** @type {LocalizedString} */ ("Refresh Presets")
});